<template>
  <f7-page name="cgm-dashboard" style="background-color:#f7f7f7;">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        이번주 학습지도
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div class="row" style="padding:4px">			
			<div class="wide-border-box title-box col-200 xsmall-200 small-200 medium-100 large-100 xlarge-100" style="height:600px;">
				<div class="tb-title">				
					<div class="right">
						<span data-progress="100" class="progressbar" style="width:16px; display:inline-block;"></span> 학생수&nbsp;&nbsp;
						<span data-progress="100" class="progressbar color-green" style="width:16px; display:inline-block;"></span> 학습량
					</div>
				</div>
				<div class="tb-body">
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar"></span></p>
						<p><span data-progress="50" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
				</div>
			</div>
		</div>
  </f7-page>
</template>

<style lang="scss" scoped>

.thin-border-box {
	border-radius: 4px;
	border: solid 1px #ddd;
	background-color: #fff;
	padding: 6px;
	margin: 4px;
}

.wide-border-box {
	border-radius: 4px;
	border: solid 1px #ddd;
	background-color: #fff;
	padding: 12px;
	margin: 4px;
}

.title-box {
	display: flex;
	flex-direction: column;

	.tb-title {
		display: flex;
		flex-direction: row;
		border-bottom: solid 1px #ddd;
		margin-bottom: 12px;
		
		.left {
			margin-right: auto;
		}

		.right {
			margin-left: auto;
		}

		h3 {
			margin: 0;
			padding: 0 0 4px 0;
		}
	}

	.tb-body {
		flex: 1;
		overflow-y: auto;
		padding-right: 6px;
	}
}

.progress-group {
	margin-bottom: 12px;

	p {
		margin: 2px 0;

		& > .progressbar {
			margin-bottom: 6px;
		}
	}
}

.top-box {
	& > p:nth-child(1) {
		margin:2px 0;
		text-align: center;

		& > i {
			font-size:10px;
		}

		& > span {
			font-size:10px;
		}
	}

	& > p:nth-child(2) {
		margin:2px 0;
		text-align: center;
		line-height: 0.8;

		& > span {
			font-size:30px;
			font-weight:600;
		}
	}

	& > p:nth-child(3) {
		margin:2px 0;
		text-align: center;

		& > span {
			font-size:10px;
		}
	}
}

</style>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import Chart from 'chart.js';

export default {
  data() {
    return {
      code: "",
      studyList: []
    }
  },
  mounted() {
	
  },
  methods: {
   
  }
}

</script>